export default __webpack_public_path__ + "static/media/Illustration.c5e01021.svg";